import { useState, useEffect } from "react";
import "./Permissions.css";
import { subscribeUser } from "../../utils/push";
import { Button } from "@mui/material";
import { Bell } from "lucide-react";
const blue = "#24b8e7";
const Permissions = ({
  onPermissionsGranted,
  eventId,
  handleContinueWithoutNotifications,
  needsPermission = false,
  appIcon,
}) => {
  const [notificationPermission, setNotificationPermission] =
    useState("prompt");

  useEffect(() => {
    const checkPermissions = async () => {
      if ("Notification" in window) {
        setNotificationPermission(Notification.permission);
      }
    };

    checkPermissions();
  }, []);

  useEffect(() => {
    if (notificationPermission === "granted" && !needsPermission) {
      if (onPermissionsGranted) {
        onPermissionsGranted();
      }
    }
  }, [needsPermission, notificationPermission, onPermissionsGranted]);

  const requestNotificationPermission = () => {
    if ("Notification" in window) {
      Notification.requestPermission().then((result) => {
        setNotificationPermission(result);
        if (result === "granted") {
          subscribeUser(eventId);
          onPermissionsGranted();
        }
      });
    }
  };
  if (notificationPermission === "granted" && !needsPermission) {
    console.log("All permissions granted", needsPermission);
    return null;
  }

  return (
    <div className="max-w-md mx-auto p-4">
      <header className="text-center mb-6 flex items-center justify-center">
        <div>
          <img
            src={appIcon}
            alt="App Icon"
            className="w-12 h-12 mr-4 rounded-md"
          />
        </div>
        <div>
          <h1 className="text-2xl font-bold">Connect with Us!</h1>
        </div>
      </header>
      <section className="bg-white dark:bg-gray-800 p-4 m-4 rounded-lg shadow space-y-4">
        <ul
          style={{
            listStyleType: "square",
            textAlign: "left",
            marginLeft: 20,
          }}
        >
          <li
            className="font-medium text-gray-900 dark:text-gray-100"
            style={{ paddingLeft: 0 }}
          >
            Enable live alerts for light show moments.
          </li>
          <li
            className="font-medium text-gray-900 dark:text-gray-100"
            style={{ paddingLeft: 0 }}
          >
            Tap notifications to join instantly when prompted.
          </li>
        </ul>

        <p className="text-center text-small muted-text my-4">
          NOTE: Notifications will discontinue post event. Functionality may
          vary due to device age & OS version.
        </p>

        <div className="flex flex-col items-center justify-center mt-6">
          <Button
            onClick={requestNotificationPermission}
            className="continue-button mb-2"
            startIcon={<Bell />}
            variant="contained"
            style={{
              color: "white",
              backgroundColor: blue,
            }}
          >
            Enable Notifications
          </Button>
          <button
            onClick={handleContinueWithoutNotifications}
            className="continue-button p-3 cursor-pointer"
            variant="contained"
            style={{
              color: "grey",
              backgroundColor: "transparent",
              border: "none",
            }}
          >
            Skip
          </button>
        </div>
      </section>
    </div>
  );
};

export default Permissions;
